import { Alert, AlertIcon, Box, Flex, List, ListItem } from '@chakra-ui/react'
import React from 'react'
import { useLanguage } from '../hooks/utility/useLanguage'
import useMobile from '../hooks/utility/useMobile'

interface Props {
  error: Error
  errorDetails?: { policy_violations?: string[] }
  onRetry?: () => void
}

const InputValidationErrorComponent: React.FC<Props> = ({ error, errorDetails, onRetry }) => {
  const { t } = useLanguage()
  const isMobile = useMobile()
  const violationList = errorDetails?.policy_violations || []

  const getErrorMessage = () => {
    switch (error.message) {
      case 'LLM_PROVIDER_USER_INPUT_BLOCKED':
        return t('errors.llmProviderUserInputBlocked')
      case 'USER_INPUT_CONTENT_VIOLATION':
      default:
        return t('errors.userInputContentViolation')
    }
  }

  return (
    <Alert
      status="error"
      borderRadius="md"
      mb={2}
      maxWidth={['80%', '80%', '70%']}
      minHeight="50px"
      alignItems="flex-start"
    >
      <AlertIcon />
      <Box flex="1">
        <Flex alignItems="center" justifyContent="space-between" width="100%">
          <Box color="gray.700" fontSize={isMobile ? 'sm' : 'md'} flex="1" display="flex" alignItems="center">
            {getErrorMessage()}
          </Box>
        </Flex>
        {violationList.length > 0 && (
          <Box mt={2}>
            <List spacing={1} styleType="disc" ml={6}>
              {violationList.map((violation, index) => (
                <ListItem key={index} fontSize="sm" color="gray.700">
                  {violation}
                </ListItem>
              ))}
            </List>
          </Box>
        )}
      </Box>
    </Alert>
  )
}

InputValidationErrorComponent.displayName = 'InputValidationError'

export const InputValidationError = React.memo(InputValidationErrorComponent)
